module.exports = __webpack_public_path__ + "static/media/calculator-result-not-allow.268e7ff1.png";